import { useEffect } from 'react'
import { marleeUIActionBus } from './marleeUIActionBus'

type UIActionHandler = (payload: Record<string, unknown>) => void

export function useMarleeUIAction(actionType: string, handler: UIActionHandler): void {
    useEffect(() => {
        const unsubscribe = marleeUIActionBus.on(actionType, handler)
        return unsubscribe
    }, [actionType, handler])
}
